import "@/App.css";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { EventSnapshot } from "@/components/site/EventSnapshot";
import { About } from "@/components/site/About";
import { VaaniSection } from "@/components/site/VaaniSection";
import { Objectives } from "@/components/site/Objectives";
import { Outcomes } from "@/components/site/Outcomes";
import { Speakers } from "@/components/site/Speakers";
import { Schedule } from "@/components/site/Schedule";
import { Audience } from "@/components/site/Audience";
import { Organizers } from "@/components/site/Organizers";
import { Venue } from "@/components/site/Venue";
import { Footer } from "@/components/site/Footer";

function App() {
  return (
    <LanguageProvider>
      <div className="App bg-background text-foreground antialiased">
        <Navbar />
        <main>
          <Hero />
          <EventSnapshot />
          <About />
          <VaaniSection />
          <Objectives />
          <Outcomes />
          <Speakers />
          <Schedule />
          <Audience />
          <Organizers />
          <Venue />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
